import { ConfiguratorType } from "@biz/Definitions";
import { Access } from "@biz/definitions/AccessDefinitions";
import { FeatureLevel, featureLevels } from "@biz/definitions/ProductDefinitions";

export class FL {
  /** lower or equal */
  static le(featureLevel: FeatureLevel, targetLevel: FeatureLevel): boolean {
    const index = featureLevels.indexOf(featureLevel)
    const targetIndex = featureLevels.indexOf(targetLevel);
    return index <= targetIndex;
  }

  /** greater than */
  static gt(featureLevel: FeatureLevel, targetLevel: FeatureLevel): boolean {
    const index = featureLevels.indexOf(featureLevel)
    const targetIndex = featureLevels.indexOf(targetLevel);
    return index > targetIndex;
  }


  /** greater or equal */
  static ge(featureLevel: FeatureLevel, targetLevel: FeatureLevel): boolean {
    const index = featureLevels.indexOf(featureLevel)
    const targetIndex = featureLevels.indexOf(targetLevel);
    return index >= targetIndex;
  }

  static fromUser(user: { access?: Access } | undefined): FeatureLevel {
    if (!user?.access)
      return "user";

    if (user?.access >= Access.Soliday)
      return "dealer"; //"soliday";
    else if (user?.access >= Access.Dealer)
      return "dealer";
    return "user"
  }

  static fromProduct(product: { featureLevel?: FeatureLevel; sourceConfigurator?: ConfiguratorType } | undefined): FeatureLevel {
    if (product?.featureLevel)
      return product.featureLevel;
    if (product?.sourceConfigurator === "sc")
      return "user";
    return "dealer"
  }
}